import { SequenceManagerAction } from "./SequenceManagerAction";


const EPlanCheckAction = {
  EPLAN_CHECK_SUCCESS: 'EPLAN_CHECK_SUCCESS'
}

const ePlanCheckComplete = (ePlanAvilable: any, customerRelatedAccountResponse: any, offerContainerId: any) => {
  return function (dispatch: any) {
    dispatch({ type: EPlanCheckAction.EPLAN_CHECK_SUCCESS, payload: { ePlanAvilable: ePlanAvilable, customerRelatedAccountResponse: customerRelatedAccountResponse, offerContainerId: offerContainerId } });
    dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['EPlanCheck'] });
  }
}

export { EPlanCheckAction, ePlanCheckComplete };